import { Component, OnInit, forwardRef } from "@angular/core";
import {
  NavController,
  AlertController,
  NavParams,
  LoadingController,
  ModalController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { HistoricoListaPage } from "../../historico-lista/historico-lista.page";
import { MdaEncontroAvaliacaoPage } from "../mda-encontro-avaliacao/mda-encontro-avaliacao.page";
import { MdaEncontroListaPage } from "../mda-encontro-lista/mda-encontro-lista.page";
import { MdaEncontroPage } from "../mda-encontro/mda-encontro.page";
import { MdaProvider } from "src/app/services/mda/mda";
import { UserProvider } from "src/app/services/user/user";
import { MdaDetalhesEncontroPage } from "../mda-detalhes-encontro/mda-detalhes-encontro.page";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { ImagePipe } from "src/app/pipes/image/image";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";

@Component({
  selector: "app-mda-detalhes",
  templateUrl: "./mda-detalhes.page.html",
  styleUrls: ["./mda-detalhes.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    ImagePipe,
    LoadingSpinnerComponent,
  ],
})
export class MdaDetalhesPage implements OnInit {
  loaded: boolean = false;
  mda: any = { pessoa: {}, dadosMDA: { proximoEncontro: {} }, ultimosEncontros: [] };
  titulo: string = "";
  discipulador: boolean = false;
  mostrarTodos: boolean = false;
  id: string = "";
  constructor(
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public mdaProvider: MdaProvider,
    public modalCtrl: ModalController,
    private translate: TranslateService,
    public userProvider: UserProvider
  ) {
    this.id = navParams.get("id");
    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  ngOnInit() {
    this.getDados();
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async getDados() {
    this.mdaProvider.getByMda(this.id).subscribe((data) => {
      this.titulo = data.titulo;
      this.discipulador = data.discipulador;
      this.mda = data;
    });
  }

  async agendarEncontro(mda: { dadosMDA: { id: any; idMdaTipo: any } }) {
    var data = { idMda: mda.dadosMDA.id, idMdaEncontroTipo: mda.dadosMDA.idMdaTipo };
    const modalPage = await this.modalCtrl.create({
      component: MdaEncontroPage,
      componentProps: data,
    });
    modalPage.present();

    (await modalPage.onWillDismiss()).data;
    this.mdaProvider.getByMda(this.id).subscribe((data) => {
      this.titulo = data.titulo;
      this.discipulador = data.discipulador;
      this.mda = data;
    });
  }

  async ultimosEncontros(mda: { dadosMDA: { id: any } }) {
    var data = { idMda: mda.dadosMDA.id };
    const modalPage = await this.modalCtrl.create({
      component: MdaEncontroListaPage,
      componentProps: data,
    });
    modalPage.present();
  }

  async listaHistoricos(mda: { dadosMDA: { id: any } }) {
    var data = { idMda: mda.dadosMDA.id };
    const modalPage = await this.modalCtrl.create({
      component: HistoricoListaPage,
      componentProps: data,
    });
    modalPage.present();
  }

  async selecionarMda(mda: any) {
    let data = {
      mda: mda,
      qualidadeDiscipulo: mda.qualidadeDiscipulo,
    };
    const modalPage = await this.modalCtrl.create({
      component: MdaEncontroAvaliacaoPage,
      componentProps: data,
    });
    modalPage.present();

    (await modalPage.onWillDismiss()).data;
    this.mdaProvider.getByMda(this.id).subscribe((data) => {
      this.titulo = data.titulo;
      this.discipulador = data.discipulador;
      this.mda = data;
    });
  }

  async openDetails(mda: any) {
    var data = { mda: mda };
    const modalPage = await this.modalCtrl.create({
      component: MdaDetalhesEncontroPage,
      componentProps: data,
    });
    modalPage.present();

    const dismissModal = await modalPage.onWillDismiss();

    if (dismissModal.data) {
      this.getDados();
    }
  }
}
